import React from 'react';

const Vip = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_12549_40988)" }, /* @__PURE__ */ React.createElement(
    "circle",
    {
      cx: "10.0048",
      cy: "10.0025",
      r: "8.54373",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5 7.08502L7.91737 8.75209L10.0012 5.83472L12.085 8.75209L15.0024 7.08502L13.7521 11.6695H6.2503L5 7.08502Z",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.5 14.1704H12.5012",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_12549_40988" }, /* @__PURE__ */ React.createElement("rect", { width: "20", height: "20", fill: "white" })))
);

export { Vip };
//# sourceMappingURL=Vip.js.map
